import React from 'react';
import { Pencil, Trash } from '@phosphor-icons/react';

export const COLUMN_CONFIG = [
  {
    'label': 'City Name',
    'path': 'cityName',
    'order': 1,
    'field': 'cityName',
  },
  {
    'label': '',
    'path': 'action_items',
    'order': 2,
    'field': 'action_items',
  },
];

export const ACTION_ITEMS = [
  { icon: <Trash />, action: 'delete' },
];
